import { ComponentProps, memo, ReactNode, useMemo } from "react"
import { ScrollView } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { usePseudoWindowDimensions } from "src/hooks/useCheckPCScreen"

type Props = {
  style?: ComponentProps<typeof ScrollView>["style"]
  children: ReactNode
  scrollEnabled?: ComponentProps<typeof ScrollView>["scrollEnabled"]
  refreshControl?: ComponentProps<typeof ScrollView>["refreshControl"]
  noPaddingBottom?: boolean
}

export const CustomScrollView = memo<Props>(
  ({ children, style, noPaddingBottom, ...rest }) => {
    const insets = useSafeAreaInsets()
    const { height } = usePseudoWindowDimensions()
    const headerHeight = 64
    const heightScroll = useMemo(() => height - headerHeight, [height])

    return (
      <ScrollView
        style={[{ height: heightScroll }, style]}
        scrollIndicatorInsets={{ right: 1 }}
        contentContainerStyle={{ paddingBottom: noPaddingBottom ? 0 : insets.bottom }}
        {...rest}
      >
        {children}
      </ScrollView>
    )
  }
)
